import { Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'ugc-image',
  shadow: false,
})
export class UgcImage {
  @Prop() imageUrl: string = '';
  @Prop() alt?: string = '';
  @Prop() size?: number = 80;
  render() {
    return (
      <Host>
        <img
          src={this.imageUrl}
          alt={this.alt}
          style={{ width: `${this.size}px`, height: `${this.size}px` }}
          class="rounded-4"
        />
      </Host>
    );
  }
}
